import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { usePatchAllMasterInventoryMutation } from "../../../Services/inventory/Inventory";
import useThemeColors from "../../vehicle/ThemeColors";
import { Loader } from "react-bootstrap-typeahead";

interface IPROPS {
    closeModal: any;
    refetch: any;
    storeValue: any;
}

const EditMasterParts: React.FC<IPROPS> = ({
    closeModal,
    refetch,
    storeValue,
}) => {
    const [inventoryName, setInventoryName] = useState(
        storeValue?.inventoryName
    );
    const [hsn, setHsn] = useState(storeValue?.hsnCode);
    const [price, setPrice] = useState(storeValue?.price_per_unit);
    const [gst, setGst] = useState(storeValue?.gst);
    const [partId, setPartId] = useState(storeValue?.partId);
    const [loading, setLoading] = useState(false);

    const [updateInventoryTrigger, { status }] =
        usePatchAllMasterInventoryMutation();

    useEffect(() => {
        if (status === "pending") {
            setLoading(true);
        } else {
            setLoading(false);
        }
    }, [status]);

    const saveHandler = async (e) => {
        e.preventDefault();
        const inventoryAddPayload = {
            inventoryName: inventoryName,
            hsnCode: hsn,
            price_per_unit: price,
            gst: gst,
            partId,
        };

        const response = await updateInventoryTrigger({
            id: storeValue?.id,
            body: inventoryAddPayload,
        });

        try {
            if (response?.data) {
                toast.success("Inventory added successfully");
                refetch();
                closeModal();
            } else if ("data" in response?.error) {
                const errorMessage = response?.error?.data as {
                    hsnCode?: string;
                    partId?: string;
                    price?: string;
                    gst?: string;
                    inventoryName?: string;
                };
                const errorToast =
                    errorMessage?.hsnCode?.[0] ||
                    errorMessage?.partId?.[0] ||
                    errorMessage?.price?.[0] ||
                    errorMessage?.gst?.[0] || 
                    errorMessage?.inventoryName?.[0]
                toast.error(errorToast);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const {
        selectedButtonBackgoundColors,
        selectedButtonColors,
    } = useThemeColors();

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <div>
                <label style={{ fontSize: "15px" }}>Part Name</label>
                <input
                    className="form-control form-control-solid"
                    type="text"
                    onChange={(e) => setInventoryName(e.target.value)}
                    value={inventoryName}
                />
            </div>
            <div>
                <label style={{ fontSize: "15px" }}>HSN code</label>
                <input
                    className="form-control form-control-solid"
                    onChange={(e) => setHsn(e.target.value)}
                    value={hsn}
                />
            </div>
            <div>
                <label style={{ fontSize: "15px" }}>Part id</label>
                <input
                    className="form-control form-control-solid"
                    onChange={(e) => setPartId(e.target.value)}
                    value={partId}
                />
            </div>
            <div>
                <label style={{ fontSize: "15px" }}>Price</label>
                <input
                    className="form-control form-control-solid"
                    onChange={(e) => setPrice(e.target.value)}
                    value={price}
                />
            </div>
            <div>
                <label style={{ fontSize: "15px" }}>GST</label>
                <input
                    className="form-control form-control-solid"
                    onChange={(e) => setGst(e.target.value)}
                    value={gst}
                />
            </div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                }}
            >
                <button className="btn btn-secondary" style={{   borderRadius: "20px"}} onClick={closeModal}>
                    Cancel
                </button>
                <button
                    style={{
                        background: `${selectedButtonBackgoundColors}`,
                        color: `${selectedButtonColors}`,
                        border: "none",
                        padding: "10px 20px",
                        borderRadius: "20px",
                        fontSize: "15px",
                    }}
                    onClick={saveHandler}
                >
                    {loading ? (
                        <>
                            Saving...
                            <Loader />
                        </>
                    ) : (
                        "Save"
                    )}
                </button>
            </div>
        </div>
    );
};

export default EditMasterParts;
